"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSSIBLE_CONFIGURATIONS = void 0;
const possible_configurations_json_1 = __importDefault(require("../generator/possible_configurations.json"));
exports.POSSIBLE_CONFIGURATIONS = possible_configurations_json_1.default;
